import { render, staticRenderFns } from "./EmployeePayslipDetails.vue?vue&type=template&id=747cd579&scoped=true"
import script from "./EmployeePayslipDetails.vue?vue&type=script&lang=js"
export * from "./EmployeePayslipDetails.vue?vue&type=script&lang=js"
import style0 from "./EmployeePayslipDetails.vue?vue&type=style&index=0&id=747cd579&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747cd579",
  null
  
)

export default component.exports